import type { CompanySiteType } from '@api';
import { TouringDataTable } from '@common';
import { useCompanySitesTableColumns } from './hooks';

type CompanySitesTablePropsType = {
  records: CompanySiteType[];
  handleDeleteCompanySite: (siteId: string) => void;
  handleEditCompanySite: (site: CompanySiteType) => void;
  handleSetSiteAsHeadquarter: (siteId: string) => void;
};

export const CompanySitesTable: React.FC<CompanySitesTablePropsType> = ({
  records,
  handleDeleteCompanySite,
  handleEditCompanySite,
  handleSetSiteAsHeadquarter,
}) => {
  const { columns } = useCompanySitesTableColumns({
    handleDeleteCompanySite,
    handleEditCompanySite,
    handleSetSiteAsHeadquarter,
  });

  return (
    <TouringDataTable<CompanySiteType>
      columns={columns}
      records={records}
      withTableBorder={false}
      withColumnBorders={false}
    />
  );
};
